<template>
  <form class="yakukyari_1st-jobsearch" id="yakukyari_1st-jobsearch" :action="path" :ref="'form'" accept-charset="UTF-8" method="post">
    <div class="search-contents_wrap section-career-fairs">
      <div class="search-contents">
        <a v-on:click.stop="currentPopup = 'Area'">
          <span class="tit-area">エリア</span>
          <p v-if="prefectures.length" class="hopen">{{ prefecturesStore.getText() }}</p>
          <p v-else>希望エリアを選択する</p>
        </a>
        <input type="hidden" name="first_career_fair_search_condition[prefecture_ids]" v-model="prefectures">
      </div>
      <div class="search-contents">
        <a v-on:click.stop="currentPopup = 'Business'">
          <span class="tit-business">業種</span>
          <p v-if="businessTypes.length" class="hopen">{{ businessTypesStore.getText() }}</p>
          <p v-else>希望業種を選択する</p>
        </a>
        <input type="hidden" name="first_career_fair_search_condition[business_types]" v-model="businessTypes">
      </div>
      <div class="search-contents">
        <a v-on:click.stop="currentPopup = 'Month'">
          <span class="tit-months">開催時期</span>
          <p v-if="months.length" class="hopen">{{ monthsStore.getText() }}</p>
          <p v-else>開催時期を選択する</p>
        </a>
        <input type="hidden" name="first_career_fair_search_condition[months]" v-model="months">
      </div>
      <div class="search-contents search-contents_keyword">
        <span class="tit-keyword">キーワード</span>
        <input type="text"
                placeholder=" 企業名・キーワードなど（任意）"
                id="form_office_search_form_text"
                name="first_career_fair_search_condition[keyword]"
                class="use_lookup-icon"
                v-model="keyword">
        <button type="submit" class="link_btn_green" ref="submit">検索</button>
      </div>
      <div class="search-contents search-contents_checkbox">
        <div class="checkbox">
          <input class="css-checkbox"
                  type="checkbox"
                  value="1"
                  name="first_career_fair_search_condition[is_online]"
                  id="first_career_fair_search_condition"
                  v-model="isOnline">
          <label class="sp_small css-label" for="first_career_fair_search_condition">オンライン開催</label>
        </div>
      </div>
    </div>

    <div v-if="currentPopup" class="sub_search_wrap sub_search_heightMax">
      <AreaComponent v-if="currentPopup === 'Area'" @close="closePopup" />
      <BusinessComponent v-if="currentPopup === 'Business'" @close="closePopup" />
      <MonthComponent v-if="currentPopup === 'Month'" @close="closePopup" />
      <div class="sub_search_wrap-modal-black-background"></div>
    </div>
  </form>
</template>

<script setup>
import { ref, computed, provide, watch } from 'vue'
import AreaComponent from './components/area'
import BusinessComponent from './components/business'
import MonthComponent from './components/month'
/* composables */
import { useAreas } from '@component_path/composables/areas.js'
import { usePrefectures } from '@component_path/composables/prefectures.js'
import { useBusinessTypes } from '@component_path/composables/businessTypes.js'
import { useMonths } from '@component_path/composables/months.js'
import { useIsOnline } from '@component_path/composables/isOnline.js'
import { useKeyword } from '@component_path/composables/keyword.js'

const props = defineProps({
  areas: { type: Array, required: true },
  clearAllAreas: { type: Object }, //条件クリア用
  conditionTypes: { type: Array, required: true },
  prefectures: { type: Array, required: true },
  path: { type: String, required: true },
  // initial~ について: ×ボタンで検索条件の変更を元に戻すため、初期状態のpropsをもつ。
  // また、propsの値を直接書き換えようとするwarningがでるので初期値を別で持つようにして回避する。
  initialCheckedIds: { type: Object },
  initialPrefectureIds: { type: Array },
  initialTypeCodes: { type: Array },
  initialMonthValues: { type: Array },
  initialIsOnline: { type: Boolean },
  initialKeyword: { type: String }
})

/* data */
const submit = ref(null)
const currentPopup = ref(null)

/* store */
const prefecturesStore = usePrefectures(props.initialPrefectureIds, props.prefectures)
const areasStore = useAreas(prefecturesStore, props.initialCheckedIds, props.areas, props.clearAllAreas)
const businessTypesStore = useBusinessTypes(props.initialTypeCodes, props.conditionTypes)
const monthsStore = useMonths(props.initialMonthValues, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
const isOnlineStore = useIsOnline(props.initialIsOnline)
const keywordStore = useKeyword(props.initialKeyword)
provide('areasStore', areasStore)
provide('businessTypesStore', businessTypesStore)
provide('monthsStore', monthsStore)

/* methods */
const closePopup = () => { currentPopup.value = null }

/* computed */
const prefectures = computed(() => prefecturesStore.prefectures.value)
const businessTypes = computed(() => businessTypesStore.businessTypes.value)
const months = computed(() => monthsStore.months.value)
const isOnline = computed({
  get: () => isOnlineStore.isOnline.value,
  set: (value) => isOnlineStore.set(value)
})
const keyword = computed({
  get: () => keywordStore.keyword.value,
  set: (value) => keywordStore.set(value)
})

watch(isOnline, () => {
  submit.value.form.submit()
})
</script>
